export default __webpack_public_path__ + "static/media/chrome-phone-apple-2.3a000094.png";